import styles from './SectionHeader2.module.css';

interface Props {
  text: string;
  /** When omitted, margin-bottom is 10px (mobile) / 60px (640px+). */
  mb?: number;
}

export default function SectionHeader2({ text, mb }: Props) {
  const useDefaultMargin = mb === undefined;
  return (
    <h2
      className={`fontVariantAlt ${styles.heading} ${useDefaultMargin ? styles.headingMarginDefault : ''}`}
      style={mb !== undefined ? { marginBottom: mb } : undefined}
    >
      {text}
    </h2>
  );
}
